import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectOption from '../../../UI/SelectMenu/SelectOption/SelectOption';
import classes from './ChildSelectionSelect.scss';


class SelectMenu extends Component {

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) {
            return;
        }
        if (this.props.closeSelect) {
            this.props.closeSelect();
        }
    }

    render() {
        const border = '1px solid var(--color-border)';
        const colorDark = 'var(--color-grey-dark-1)';
        
        return (
            <div className={`u-width100Percent u-relative`} ref={node => this.node = node}>
                <div 
                    className={classes.Field}
                    style={{ borderBottom: `${border}` }}
                    onClick={this.props.toggleClicked}><span>{this.props.value} year</span><span><FontAwesomeIcon icon="angle-down" color={`${colorDark}`} size="1x" /></span></div>
                    {
                        this.props.active ? 
                        <ul className={`${classes.Select} u-boxShadowThin u-backgroundColorWhite u-borderRadius4 u-absolute u-overflowScroll`} style={{height: '16rem'}}>
                            {
                                this.props.mapping.map((data) => <SelectOption key={data.slNo} onClick={() => this.props.clicked(data.slNo)}> {data.ageName}</SelectOption>)
                            }
                        </ul> : null
                    }
            </div>
        );
    }
}

export default SelectMenu;


// WEBPACK FOOTER //
// ./src/components/Travellers/ChildSelection/ChildSelectionSelect/ChildSelectionSelect.js